<template>
  <div id="app" :class="{ 'management-app': isManagement }">
    <div v-if="!isManagement">
      <TheHeader />
      <div class="content">
        <router-view />
      </div>
      <PageTop class="page-top" />
      <TheFooter class="footer" />
    </div>
    <div class="managemant-content" v-else>
      <router-view />
    </div>
    <div v-if="!hiddenMessage" class="message">
      <div v-if="isMessage" class="message-dialog">
        <p>歡迎訂閱我們的 LINE 官方帳號</p>
        <p style="color:#1AB297;margin-bottom: 15px;">
          點擊下方按鈕獲得最新資訊
        </p>

        <a href="https://lin.ee/saHO1SK" style="display: inline-block;"
          ><img
            src="https://scdn.line-apps.com/n/line_add_friends/btn/zh-Hant.png"
            alt="加入好友"
            height="49"
            border="0"
        /></a>

        <img
          src="@/assets/close-icon.png"
          style="width: 13px;position: absolute;
                    right: 0px; top: 0px;cursor: pointer;padding: 10px;"
          @click="isMessage = false"
        />
      </div>
      <img
        src="@/assets/message.png"
        style="cursor: pointer;width: 100%;"
        class="message-img"
        @click="isMessage = true"
      />
    </div>
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import PageTop from "@/components/PageTop.vue";

export default {
  components: {
    TheHeader,
    TheFooter,
    PageTop
  },
  data: () => ({
    isMessage: true,
    hiddenMessage: false
  }),
  computed: {
    isManagement() {
      if (
        this.$route.matched[0].path == "/management" ||
        this.$route.matched[0].path == "/login"
      ) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    const name = [
      "management",
      "banner-manager",
      "news-manager",
      "rank-manager",
      "teacher-manager",
      "course-schedule-manager",
      "login"
    ];
    if (name.includes(this.$route.name)) {
      this.hiddenMessage = true;
    }
  }
};
</script>

<style lang="scss">
html,
body,
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
  padding: 0;
  scroll-behavior: smooth;
}

.management-app {
  max-width: initial !important;

  .managemant-content {
    display: flex;
  }
}

.mobile {
  display: none;
}

@media (max-width: 1023px) {
  .desktop {
    display: none !important;
  }

  .mobile {
    display: block !important;
  }
}
</style>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Noto+Sans+TC:400,500,700&display=swap&subset=chinese-traditional");
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@400;500;700&family=Noto+Sans+TC:wght@400;500;700&display=swap");

#app {
  font-family: "Noto Sans TC", "Noto Sans SC", sans-serif, "Avenir", Helvetica,
    Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  max-width: 1200px;
  margin: auto;
}

* {
  font-family: "Noto Sans TC", "Noto Sans SC", sans-serif, "Avenir", Helvetica,
    Arial !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.content {
  margin-top: -25px;
  margin-bottom: -43px;
  // since we already know the height of header and footer
  // so we can use calc to calcuate the content min-height
  // to make sure the footer will always sticky on bottom
  min-height: calc(100vh - 224px - 104px + 25px + 43px);
}

.footer {
  position: relative;
}

.page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 2;
}

.message {
  width: 52px;
  position: fixed;
  bottom: 80px;
  right: 16px;
  z-index: 999;
}
.message-img {
  filter: brightness(0) saturate(100%) invert(83%) sepia(11%) saturate(1011%)
    hue-rotate(28deg) brightness(93%) contrast(87%);
}
.message-dialog {
  width: 240px;
  background-color: #fff;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
  position: absolute;
  right: 0;
  bottom: 0;
  border-radius: 2px;
  padding: 15px 15px 10px;
  z-index: 9999;
  p {
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss">
.swal2-container {
  z-index: 9999 !important;
}
</style>
